import { Flex, useColorModeValue } from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';
import { Button } from 'src/components/atoms/Button';
import { OptimizationFormInputs } from './index';

type FooterProps = {
  onCancelClick: () => void;
};
export const Footer: React.FC<FooterProps> = ({ onCancelClick }) => {
  const {
    formState: { isSubmitting },
  } = useFormContext<OptimizationFormInputs>();
  const cancelHoverBg = useColorModeValue('gray.200', 'whiteAlpha.300');

  return (
    <Flex justifyContent="flex-end" mt={10}>
      <Button
        buttonName="opt-modal-cancel"
        onClick={onCancelClick}
        backgroundColor="surface.control"
        color="text.title"
        _hover={{ backgroundColor: cancelHoverBg }}>
        Cancel
      </Button>
      <Button
        buttonName="opt-modal-optimize"
        isLoading={isSubmitting}
        backgroundColor="icon.green"
        type="submit"
        ml="20px">
        Optimize
      </Button>
    </Flex>
  );
};
